<template>
  <div class="px-2 pt-10">

    <div class=" items-center rounded-md bg-white p-6 shadow-mdv">
      <p class="text-gray-700 text-xl my-4 flex flex-row items-center font-semibold">
        <OutlineDocumentSearchIcon class="size-6 mr-4 text-gray-700" />Consultar trámites del AAN
      </p>
      <div class="mb-4" v-if="errorMessage">
        <MessageCard type="error" :message="errorMessage" />
      </div>
      <label class=" text-sm" for="tramiteNumeracion">INGRESAR NÚMERO DE SOLICITUD / TRÁMITE</label>

      <div class="flex flex-row w-full space-x-4 mt-2">
        <input type="text" v-model="tramiteNumeracion" class="w-full" @keydown="useOnlyNumbers" placeholder="Ej: 123">

        <Button text="Buscar" @click="search" :disabled="loading || !tramiteNumeracion">
          <template #right>
            <LoadingCircle v-if="loading" class="h-4 w-4" />
          </template>
        </Button>
        <button @click="limpiar" :disabled="loading || !tramiteNumeracion"
          class="rounded-md disabled:cursor-not-allowed border shadow-sm  border-gray-300 bg-white text-gray-600 hover:enabled:bg-cool-gray-100 focus:enabled:border-blue-300  disabled:text-gray-500 disabled:bg-gray-100 disabled:border-gray-300 disabled:opacity-50 ">
          <div class="flex flex-row justify-center items-center px-4 py-2 space-x-2">
            <OutlineTrashIcon class=" size-4" />
          </div>
        </button>
      </div>
      <div class="rounded-lg border border-gray-100 bg-colescba-blue-100 p-4 mt-4 flex flex-row " v-if="result">
        <div class="w-1/3 flex flex-col">
          <p class="text-sm inline-block font-semibold text-gray-600">NÚMERO DE TRÁMITE</p>
          <p class="inline-block text-gray-500">{{ numeroTramiteConsulta }}</p>
        </div>
        <div class="w-1/3 flex flex-col">
          <p class="text-sm inline-block font-semibold text-gray-600">DESCRIPCIÓN</p>
          <p class="inline-block text-gray-500">{{ result.descripcion }}</p>
        </div>
        <div class="w-1/3 flex flex-col">
          <p class="text-sm inline-block font-semibold text-gray-600">ESTADO</p>
          <div class="text-gray-500 flex flex-row space-x-2 items-center">
            <div class="rounded-full w-2 h-2 rounded-full bg-colescba-blue-600"></div>
            <p class="inline-block text-colescba-blue-600">{{ result.estado }}</p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import { useService } from '@colescba/app-vue'
import { useInput } from '@/mixins/input'
export default {
  mixins: [useService('api'), useInput()],

  data() {
    return {
      loading: false,
      tramiteNumeracion: '',
      numeroTramiteConsulta: '',
      result: null,
      errorMessage: null
    }
  },


  methods: {

    async search() {
      try {
        this.errorMessage = null
        this.result = null
        this.numeroTramiteConsulta = this.tramiteNumeracion
        this.result = await this.api.getResultadoSolicitud(this.tramiteNumeracion)
      } catch (error) {
        this.errorMessage = error['message']
        if (error.response.data.status === 400) {
          this.limpiar()
          this.errorMessage = 'Ocurrió un error al buscar el tramite'
        } else if (error.response.data.status === 404) {
          this.errorMessage = error.response.data.message
        }

      }
    },
    limpiar() {
      this.numeroTramiteConsulta = ''
      this.tramiteNumeracion = ''
      this.result = null
      this.errorMessage = null
    }

  }
}
</script>
